import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import ViewTitle from '../../../components/ejected/ViewTitle';
import ListStatistics from '../../../components/ListStatistics';
import { connect } from 'react-redux';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

export const Header = ({
  classes,
  className,
  title,
  total,
  currentCompany,
  aggregationParams,
  ...rest
}) => {
  const hasCreate = rest.actions.props.hasCreate;
  return (
  <div>
    <div className={classnames(classes.root, className)}>
      <ViewTitle title={title} addButton={currentCompany && currentCompany.id !== 'all' && hasCreate} />
    </div>
    <div>
      <ListStatistics total={total} accept={aggregationParams.verified} visited={aggregationParams.visited} result={aggregationParams.treaty} />
    </div>
  </div>)
};

Header.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.any,
  total: PropTypes.number.isRequired
};

const StyledHeader = withStyles(styles)(Header);

export default connect(state => ({
  aggregationParams: state.sc.aggregationParams
}), {})(StyledHeader);



// WEBPACK FOOTER //
// ./src/pages/callcenter/customer/Header.js